(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('RequestCheckinModalController', [
        '$rootScope',
        '$scope',
        'CheckouteeName',
        'ResourceId',
        'isProprietor',
        '$translate',
        'MessageManager',
        'ResourceService',
        'UserCollectionService',
        RequestCheckinModalController
    ]);
    function RequestCheckinModalController($rootScope, $scope, CheckouteeName, ResourceId, isProprietor, $translate, MessageManager, ResourceService, UserCollectionService) {
        $scope.translationVariables = {
            Name : CheckouteeName
        };
        $scope.isProprietor = isProprietor;
        $scope.modalForm = {
            reasonText : ''
        };
        $scope.requestCheckInHandler = function() {
            $scope.apiCallInProgress = true;
            ResourceService.pokeCheckoutee(ResourceId, $scope.modalForm.reasonText, $scope.modalForm.notifyOwners).then(function(response) {
                MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.REQUEST_CHECKIN_MODAL.SUCCESS_WHILE_REQUESTING_CHECKIN'));
                $scope.$close();
            }, function(response) {
                MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.REQUEST_CHECKIN_MODAL.ERROR_WHILE_REQUESTING_CHECKIN'));
                $scope.$dismiss();
            });
        };
    }
}());
